<div class="space-y-3">
  <!-- Profit & Loss Summary -->
  <div class="bg-ddf4e7a3 w-full rounded-lg py-2 px-3">
    <p class="text-center font-semibold text-3b3a3a text-xl mb-2">Profit & Loss</p>
    <div class="bg-white w-full rounded-xl overflow-x-scroll">
      <table class="listtable2 w-full overflow-hidden">
        <thead class="bg-fbfbfb border border-b-0 border-ededed">
          <tr>
            <th class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="flex items-center gap-2 text-[17px] font-medium text-0d5bab capitalize">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.40001 15.6C9.06376 15.6 9.60001 16.1362 9.60001 16.8C9.60001 17.4638 9.06376 18 8.40001 18H2.40001C1.73626 18 1.20001 17.4638 1.20001 16.8V10.8C1.20001 10.1362 1.73626 9.6 2.40001 9.6C3.06376 9.6 3.60001 10.1362 3.60001 10.8V13.9013L9.95251 7.54875C10.4213 7.08 11.1825 7.08 11.6513 7.54875L15.6 11.5013L20.7525 6.3525C21.2213 5.88375 21.9825 5.88375 22.4513 6.3525C22.92 6.82125 22.92 7.5825 22.4513 8.05125L16.4513 14.0513C15.9825 14.52 15.2213 14.52 14.7525 14.0513L10.8 10.0987L5.29876 15.6H8.40001Z"
                      fill="#BB0000" />
                  </svg>
                  Expenditure
                </p>
                <p class="text-[17px] font-medium text-0d5bab capitalize">₹ Amount</p>
              </div>
            </th>
            <th class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="flex items-center gap-2 text-[17px] font-medium text-0d5bab capitalize">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.6 8.4C14.9363 8.4 14.4 7.86375 14.4 7.2C14.4 6.53625 14.9363 6 15.6 6H21.6C22.2638 6 22.8 6.53625 22.8 7.2V13.2C22.8 13.8638 22.2638 14.4 21.6 14.4C20.9363 14.4 20.4 13.8638 20.4 13.2V10.0987L14.0475 16.4513C13.5788 16.92 12.8175 16.92 12.3488 16.4513L8.4 12.4987L3.2475 17.6475C2.77875 18.1163 2.0175 18.1163 1.54875 17.6475C1.08 17.1788 1.08 16.4175 1.54875 15.9487L7.54875 9.94875C8.0175 9.48 8.77875 9.48 9.2475 9.94875L13.2 13.9013L18.7013 8.4H15.6Z"
                      fill="#018F37" />
                  </svg>
                  Revenue
                </p>
                <p class="text-[17px] font-medium text-0d5bab capitalize">₹ Amount</p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Combine Trading and P&L for Summary -->
          <tr *ngFor="let row of getRows(data.profit_loss_account.expenditure, data.profit_loss_account.revenue)"
            class="border border-ededed">
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="row.exp" class="flex items-center justify-between gap-2">
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.exp.name }}</p>
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.exp.amount | number:'1.2-2' }}</p>
              </div>
            </td>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="row.rev" class="flex items-center justify-between gap-2">
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.rev.name }}</p>
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.rev.amount | number:'1.2-2' }}</p>
              </div>
            </td>
          </tr>
          <tr *ngIf="data.profit_loss_account.net_profit > 0 || data.profit_loss_account.net_loss > 0"
            class="border border-ededed">
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="data.profit_loss_account.net_profit > 0" class="flex items-center justify-between gap-2">
                <p class="text-lg font-medium text-0bb60b capitalize">Net Profit</p>
                <p class="text-lg font-medium text-0bb60b capitalize">{{ data.profit_loss_account.net_profit |
                  number:'1.2-2' }}</p>
              </div>
            </td>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="data.profit_loss_account.net_loss > 0" class="flex items-center justify-between gap-2">
                <p class="text-lg font-medium text-bb0000 capitalize">Net Loss</p>
                <p class="text-lg font-medium text-bb0000 capitalize">{{ data.profit_loss_account.net_loss |
                  number:'1.2-2' }}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot class="bg-fed40240 border-t-2 border-977f06">
          <tr>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="text-xl font-medium text-black capitalize">Total</p>
                <p class="text-xl font-medium text-black capitalize">₹ {{ data.profit_loss_account.total_expenditure |
                  number:'1.2-2' }}</p>
              </div>
            </td>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="text-xl font-medium text-black capitalize">Total</p>
                <p class="text-xl font-medium text-black capitalize">₹ {{ data.profit_loss_account.total_revenue |
                  number:'1.2-2' }}
                </p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- Capital Account -->
  <!-- <div class="bg-faf3e1c7 w-full rounded-lg py-2 px-3">
    <p class="text-center font-semibold text-3b3a3a text-xl mb-2">Capital Account</p>
    <div class="bg-white w-full rounded-xl overflow-x-scroll">
      <table class="listtable2 w-full overflow-hidden">
        <thead class="bg-fbfbfb border border-b-0 border-ededed">
          <tr>
            <th class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="flex items-center gap-2 text-[17px] font-medium text-0d5bab capitalize">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.40001 15.6C9.06376 15.6 9.60001 16.1362 9.60001 16.8C9.60001 17.4638 9.06376 18 8.40001 18H2.40001C1.73626 18 1.20001 17.4638 1.20001 16.8V10.8C1.20001 10.1362 1.73626 9.6 2.40001 9.6C3.06376 9.6 3.60001 10.1362 3.60001 10.8V13.9013L9.95251 7.54875C10.4213 7.08 11.1825 7.08 11.6513 7.54875L15.6 11.5013L20.7525 6.3525C21.2213 5.88375 21.9825 5.88375 22.4513 6.3525C22.92 6.82125 22.92 7.5825 22.4513 8.05125L16.4513 14.0513C15.9825 14.52 15.2213 14.52 14.7525 14.0513L10.8 10.0987L5.29876 15.6H8.40001Z"
                      fill="#BB0000" />
                  </svg>
                  Expenditure
                </p>
                <p class="text-[17px] font-medium text-0d5bab capitalize">₹ Amount</p>
              </div>
            </th>
            <th class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="flex items-center gap-2 text-[17px] font-medium text-0d5bab capitalize">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.6 8.4C14.9363 8.4 14.4 7.86375 14.4 7.2C14.4 6.53625 14.9363 6 15.6 6H21.6C22.2638 6 22.8 6.53625 22.8 7.2V13.2C22.8 13.8638 22.2638 14.4 21.6 14.4C20.9363 14.4 20.4 13.8638 20.4 13.2V10.0987L14.0475 16.4513C13.5788 16.92 12.8175 16.92 12.3488 16.4513L8.4 12.4987L3.2475 17.6475C2.77875 18.1163 2.0175 18.1163 1.54875 17.6475C1.08 17.1788 1.08 16.4175 1.54875 15.9487L7.54875 9.94875C8.0175 9.48 8.77875 9.48 9.2475 9.94875L13.2 13.9013L18.7013 8.4H15.6Z"
                      fill="#018F37" />
                  </svg>
                  Revenue
                </p>
                <p class="text-[17px] font-medium text-0d5bab capitalize">₹ Amount</p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getRows(data.capital_account.expenditure, data.capital_account.revenue)"
            class="border border-ededed">
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="row.exp" class="flex items-center justify-between gap-2">
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.exp.name }}</p>
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.exp.amount | number:'1.2-2' }}</p>
              </div>
            </td>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div *ngIf="row.rev" class="flex items-center justify-between gap-2">
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.rev.name }}</p>
                <p class="text-base font-normal text-2c2c2c capitalize">{{ row.rev.amount | number:'1.2-2' }}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot class="bg-fed40240 border-t-2 border-977f06">
          <tr>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="text-xl font-medium text-black capitalize">Total</p>
                <p class="text-xl font-medium text-black capitalize">₹ {{ data.capital_account.total_expenditure |
                  number:'1.2-2' }}</p>
              </div>
            </td>
            <td class="px-2 py-1.5 whitespace-nowrap">
              <div class="flex items-center justify-between gap-2">
                <p class="text-xl font-medium text-black capitalize">Total</p>
                <p class="text-xl font-medium text-black capitalize">₹ {{ data.capital_account.total_revenue |
                  number:'1.2-2' }}</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div> -->
</div>